import { WPQueryParams } from './types';

// Keep using blog.gildy.it for API calls, but transform URLs in the frontend
const WP_API_URL = 'https://blog.gildy.it/wp-json/wp/v2/';

/**
 * Fetch posts from WordPress with proper category handling
 */
export const fetchWordPressPosts = async (params: WPQueryParams = {}) => {
  try {
    // Costruisci URL base
    const url = new URL(`${WP_API_URL}posts`);
    
    // Aggiungi parametri standard
    url.searchParams.append('_embed', 'true');
    url.searchParams.append('per_page', String(params.perPage || 10));
    url.searchParams.append('page', String(params.page || 1));
    
    // Gestione categoria - assicurati che sia passata come 'categories'
    // L'API WordPress vuole 'categories' (non 'category')
    if (params.category !== undefined && params.category !== null) {
      const categoryId = typeof params.category === 'string' 
        ? parseInt(params.category, 10) 
        : params.category;
        
      if (!isNaN(Number(categoryId)) && Number(categoryId) > 0) {
        console.log(`[WordPress API] Filtrando per categoria ID: ${categoryId}`);
        url.searchParams.append('categories', String(categoryId));
      }
    } else {
      console.log('[WordPress API] Nessuna categoria specificata, recupero tutti i post');
    }
    
    // Gestione ricerca - utilizza il parametro 'search' dell'API WordPress
    if (params.search && params.search.trim().length > 0) {
      console.log(`[WordPress API] Ricerca per termine: "${params.search}"`);
      url.searchParams.append('search', params.search.trim());
    }
    
    console.log(`[WordPress API] Fetching posts from: ${url.toString()}`);
    
    const response = await fetch(url.toString(), {
      headers: {
        'Accept': 'application/json'
      }
    });
    
    if (!response.ok) {
      throw new Error(`WordPress API error: ${response.status} ${response.statusText}`);
    }
    
    const data = await response.json();
    console.log(`[WordPress API] Ricevuti ${data.length} post`);
    
    return data;
  } catch (error) {
    console.error('[WordPress API] Error fetching posts:', error);
    return [];
  }
};

/**
 * Fetch a post by slug
 */
export const fetchWordPressPostBySlug = async (slug: string) => {
  try {
    const url = new URL(`${WP_API_URL}posts`);
    url.searchParams.append('_embed', 'true');
    url.searchParams.append('slug', slug);
    
    console.log(`[WordPress API] Fetching post by slug: ${slug}`);
    
    const response = await fetch(url.toString(), {
      headers: {
        'Accept': 'application/json'
      }
    });
    
    if (!response.ok) {
      throw new Error(`WordPress API error: ${response.status} ${response.statusText}`);
    }
    
    const posts = await response.json();
    
    // L'API restituisce un array, anche se filtrando per slug
    // dovremmo ottenere al massimo un risultato
    if (posts && posts.length > 0) {
      console.log(`[WordPress API] Post trovato con slug: ${slug}`);
      return posts[0];
    }
    
    console.log(`[WordPress API] Nessun post trovato con slug: ${slug}`);
    return null;
  } catch (error) {
    console.error(`[WordPress API] Error fetching post by slug ${slug}:`, error);
    return null;
  }
};

/**
 * Fetch categories from WordPress
 */
export const fetchWordPressCategories = async () => {
  try {
    const url = `${WP_API_URL}categories?per_page=100`;
    
    console.log(`[WordPress API] Fetching categories from: ${url}`);
    
    const response = await fetch(url, {
      headers: {
        'Accept': 'application/json'
      }
    });
    
    if (!response.ok) {
      throw new Error(`WordPress API error: ${response.status} ${response.statusText}`);
    }
    
    const categories = await response.json();
    console.log(`[WordPress API] Ricevute ${categories.length} categorie`);
    
    return categories;
  } catch (error) {
    console.error('[WordPress API] Error fetching categories:', error);
    return [];
  }
};

/**
 * Fetch tags from WordPress
 */
export const fetchWordPressTags = async () => {
  try {
    const url = `${WP_API_URL}tags?per_page=100`;
    
    console.log(`[WordPress API] Fetching tags from: ${url}`);
    
    const response = await fetch(url, {
      headers: {
        'Accept': 'application/json'
      }
    });
    
    if (!response.ok) {
      throw new Error(`WordPress API error: ${response.status} ${response.statusText}`);
    }
    
    const tags = await response.json();
    console.log(`[WordPress API] Ricevuti ${tags.length} tags`);
    
    return tags;
  } catch (error) {
    console.error('[WordPress API] Error fetching tags:', error);
    return [];
  }
};
